import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import AjaxButton from "src/shared/form/ajax_button";
import { addQuestionUpvote, removeQuestionUpvote } from "../actions.jsx";

export default function QuestionsUpVoteButton({ videoRoom, question, upVoteUrl }) {
  const dispatch = useDispatch()
  const tagOwner = useSelector(state => state.tagOwner)
  const questionsUrl = (useSelector((state) => state.questionUpvoteUrl) || upVoteUrl).replace("@video_room_id@", videoRoom.id)
  const questionUpvotes = useSelector(state => state.questionUpvotes) || []
  const isUpvoted = questionUpvotes.some(questionUpvote => questionUpvote.event_question_id == question.id)

  if (!videoRoom) {
    return <div className="alert alert-danger">
      VIDEO ROOM NOT FOUND
    </div>
  }

  if (!question) {
    return <div className="alert alert-danger">
      QUESTION NOT FOUND
    </div>
  }
  const onSuccess = (data) => {
    if (data.data.status === "OK") {
      if (data.data.upvote_removed) {
        dispatch(removeQuestionUpvote({ event_question_id: question.id }))
      } else if (data.data.question_upvote) {
        dispatch(addQuestionUpvote(data.data.question_upvote))
      } else {
        alert("Error while upvoting")
      }
    } else {
      alert("Error while upvoting", error)
    }
  }

  return <AjaxButton method="put"
    className={classNames("upvote-button btn btn-link h-100", { "upvoted": isUpvoted })}
    style={{ color: "#6c757d" }}
    doNotSetFaClass={!isUpvoted}
    icon="far fa-thumbs-up align-middle"
    url={questionsUrl}
    data={{
      "question_id": question.id
    }}
    onSuccess={onSuccess}
    onError={(error) => {
      console.log(error)
      alert("Error while upvoting", error)
    }}
  />
}
